import styled from 'styled-components'

import { mq, pxToRem, sizes } from '../../theme'
import RichText from '../RichText'
import Icon from '../Icon'

export const Container = styled.div`
  transition: transform 0.3s linear;
  &:not([data-open='true']) {
  }
`
export const Summary = styled.dt`
  position: relative;
  display: flex;
  flex-flow: row;
  list-style: none;
  padding-inline: ${pxToRem(0)} ${pxToRem(46)};
  padding-block: ${pxToRem(32)} ${pxToRem(32)};
  cursor: pointer;
  &,
  &:focus {
    outline: 0 none;
  }
  &:focus-visible {
    outline: 0 none;
  }
`
export const Label = styled.span`
  ${({ theme }) => theme.textStyles.m375_h2}
  text-wrap: balance;
  @media ${mq(sizes.desktop)} {
    ${({ theme }) => theme.textStyles.d1440_h2}
  }
`
export const Toggle = styled.span`
  position: absolute;
  inset-block-start: 50%;
  inset-inline-end: ${pxToRem(0)};
  flex: 0 0 auto;
  display: grid;
  grid-template-columns: auto;
  grid-template-columns: auto;
  // using half the height here because I need the translate rule for something else
  // + not exactly centered
  margin-block-start: ${pxToRem(-16)};
  transition: transform 0.3s linear;
  ${Summary}:not([aria-expanded='true']) & {
  }
`
export const _Icon = styled(Icon)`
  grid-column: 1;
  grid-row: 1;
  aspect-ratio: 1;
  width: ${pxToRem(40)};
  opacity: 0;
`
export const OpenIcon = styled(_Icon)`
  scale: 0 1;
  opacity: 1; // always visible but scaled
  transition:
    rotate 0.15s ease-out,
    scale 0.15s linear;
  ${Summary}:active &,
  ${Summary}:hover & {
    rotate: 90deg;
  }
  ${Summary}:not([aria-expanded='true']) & {
    opacity: 1;
    scale: 1 1;
    transition:
      rotate 0.15s ease-out,
      scale 0.15s linear;
  }
`
export const CloseIcon = styled(_Icon)`
  ${Summary}[aria-expanded='true'] & {
    opacity: 1;
  }
`
export const Wrapper = styled.dd`
  display: block;
  overflow: visible;
  opacity: 1;
  transform: translate3D(0, 0, 0);
  margin: unset;
  overflow: hidden;
  height: 0;
  max-height: 300vh; // this is stupid but it's going to work
  transition:
    visibility 0.3s linear 0s,
    max-height 0s linear 0s;
  &[hidden] {
    display: block;
    max-height: 0;
    visibility: hidden; // !important to prevent focus when hidden
    transition:
      visibility 0s linear 0.3s,
      max-height 0s linear 1s;
  }
`
export const Content = styled.div`
  display: flex;
  flex-flow: column;
  gap: ${pxToRem(24)};
  width: 100%;
  height: auto;
  padding-block: ${pxToRem(0)} ${pxToRem(32)};
  @media ${mq(sizes.desktop)} {
    gap: ${pxToRem(40)};
    padding-inline-end: ${pxToRem(232)};
  }
`
export const _RichText = styled(RichText)`
  display: flex;
  flex-flow: column;
  gap: ${pxToRem(16)};
  ${({ theme }) => theme.textStyles.m375_body}
  padding-inline-end: ${pxToRem(60)};
  @media ${mq(sizes.desktop)} {
    ${({ theme }) => theme.textStyles.d1440_body}
    padding-inline-end: 0;
  }
`
export const ActionButtons = styled.div`
  display: flex;
  flex-flow: column;
  gap: ${pxToRem(16)};
  @media ${mq(sizes.desktop)} {
    flex-flow: row;
  }
`
